import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalDialogComponent, ModalDialogModule } from '@vg-constellation/angular-20/modal-dialog';
import { ContentUtil } from '../../utils/content/content.util';
import { ButtonModule } from '@vg-constellation/angular-20/button';

@Component({
	selector: 'zci-light-reg-nav-top',
	templateUrl: './light-reg-nav-top.component.html',
	styleUrls: ['./light-reg-nav-top.component.scss'],
	imports: [
		ButtonModule,
		ModalDialogModule,
	],
})
export class LightRegNavTopComponent {
	@Input() flowCaption: string;

	@Output() quitClickEvent = new EventEmitter<void>();

	@ViewChild('quitButtonModalDialog', { static: false })
	quitButtonModalDialog!: ModalDialogComponent;

	addUserFlowGrantorContent = ContentUtil.grantorFragmentContent.add_user;
}
